$ = require 'jquery'
_ = require 'underscore'
Auth = require 'db/auth'
BaseDirectoryView = require 'views/directory/base-directory-view'
Controller = require 'controller'
DirectoryEnabledView = require 'views/directory/directory-enabled-view'
DirectoryListingView = require 'views/directory/directory-listing-view'
DirectoryHeaderView = require 'views/directory/directory-header-view'
DirectoryHomeView = require 'views/directory/directory-home-view'
DirectorySearchView = require 'views/directory/directory-search-view'
DirectorySpinnerView = require 'views/directory/directory-spinner-view'
DirectoryPageView = require 'views/directory/directory-page-view'
DirectorySidebarView = require 'views/directory/directory-sidebar-view'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
ModelLoader = require 'db/model-loader'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
Promise = require 'bluebird'
trackUe = require 'debug/trackUe'
React = require 'react'
UserInput = require 'views/internal/user-input'
View = require 'view'
xtend = require 'xtend'

{ categories, featuredPlugins } = require 'data/directory'

splitTerms = (term) ->
  if term?
    _.compact term.toLowerCase().split(' ')
  else
    return []

getPageName = (section, category, idPlugin, search) ->
  page = 'home page'

  if search
    page = 'search'
  else if idPlugin
    page = 'list page'
  else if section in ['enabled', 'custom']
    page = section + ' page'
  else if section == 'category'
    page = "category #{ category } page"

  return "Power-Up directory #{ page }"

module.exports = class DirectoryView extends View
  className: 'directory-wrapper'

  initialize: ({ @boardView }) ->
    super

    # State
    @featuredPlugins = []
    @history = []
    @isLoading = true
    @plugins = []
    @search = null

    # Layout Subviews
    @headerView = @subview(DirectoryHeaderView, @model, directoryView: @)
    @sidebarView = @subview(DirectorySidebarView, @model, directoryView: @)

    # Routes
    @category = @options.category
    @section = @options.section
    @idPlugin = @options.idPlugin

    # Redirect invalid routes to home.
    if @section? && !_.contains(['enabled', 'category', 'custom'], @section)
      @navigate()

    if @category? && !_.contains(categories, @category)
      @navigate()

    @_loadPlugins()

    @listenTo @model, 'change:powerUps': @onPluginChange
    @listenTo @model.boardPluginList, 'add remove reset': @onPluginChange
    @subscribe pluginsChangedSignal(@model), => @onPluginChange()

    UserInput.addHandler(@, {
      scope: 'power_ups_directory'
    })

    @trackSearch = _.debounce @trackSearch, 5000, true

  events:
    'shortcut': 'shortcut'
    'click .js-directory-responsive-overlay': 'toggleNavigationMenu'

  shortcut: (key) ->
    switch key
      when Keys.Escape
        if !@$('.js-directory-search').is(":focus")
          @boardView.closeDirectory()
          ["Esc - Close Power-Ups Directory", "Power-Ups Directory"]

  onPluginChange: (e) ->
    @setBodyHeight()

  toggleNavigationMenu: ->
    directorySidebar = $('.js-directory-sidebar')
    responsiveOverlay = $('.js-directory-responsive-overlay')

    if directorySidebar.hasClass('active')
      directorySidebar.removeClass('active')
      responsiveOverlay.removeClass('active')
    else
      directorySidebar.addClass('active')
      responsiveOverlay.addClass('active')

  # ------- Data Methods -------
  # Load Plugins
  _loadPlugins: ->
    @model.getAvailablePlugins()
      .then (plugins) =>
        @plugins = plugins
        @pluginTerms = {}
        _.each plugins, (plugin) =>
          io = PluginIOCache.get(plugin)

          @pluginTerms[plugin.id] = _.flatten [
            splitTerms io.getName()
            splitTerms io.getDescription()
          ]

        @isLoading = false
        @sidebarView.render()
        @renderSubview()

  # Get hardcoded featured plugins
  getFeaturedPlugins: ->
    _.chain(featuredPlugins)
      .map (heroImage, id) =>
        featuredPlugin = _.find @plugins, (plugin) -> plugin.id == id
        if featuredPlugin
          featuredPlugin.heroImage = heroImage
        return featuredPlugin
      .compact()
      .value()

  # Get plugins for the current category
  getPluginsForCategory: ->
    _.chain @plugins
      .filter (plugin) => @category in plugin.get('categories')
      .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
      .value()

  # Get custom plugins for board
  getCustomPlugins: ->
    _.chain @plugins
      .filter (plugin) -> !plugin.get('public')
      .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
      .value()

  # Search logic
  getPluginsForSearch: ->
    searchWords = splitTerms @search

    _.chain @plugins
    .filter (plugin) =>
      pluginWords = @pluginTerms[plugin.id]

      [completeWords..., partialWord] = searchWords

      if _.isEmpty(completeWords) || _.isEmpty(_.intersection(completeWords, pluginWords))
        if !_.any(pluginWords, (str) -> str.substring(0, partialWord.length) == partialWord)
          return false

      return true
    .compact()
    .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
    .value()

  updateSearch: (searchTerm) ->
    return if searchTerm == @search
    @search = searchTerm
    @renderSubview()

  trackSearch: ->
    trackUe(getPageName(@section, @category, @idPlugin), 'opens', @getCurrentPage())

  # ------- Navigation Methods -------
  getCurrentPage: ->
    getPageName(@section, @category, @idPlugin, @search)

  navigate: (section, category, idPlugin, isNavigatingBack)->
    # Push to history if we're not traversing back or already on the same page
    if !isNavigatingBack && !_.isEqual({ @section, @category, @idPlugin }, { section, category, idPlugin })
      @history.push { @section, @category, @idPlugin }

    baseSlug = 'power-ups'

    if idPlugin
      baseSlug = 'power-up'
      trackUe(@getCurrentPage(), 'opens', getPageName(section, category, idPlugin), '', '', '', idPlugin)
    else
      trackUe(@getCurrentPage(), 'opens', getPageName(section, category))

    @section = section
    @category = category
    @idPlugin = idPlugin

    path = []
    path.push(@section) if @section?
    path.push(@category) if @category?
    path.push(@idPlugin) if @idPlugin?

    Controller.setBoardLocation(
      @model.id,
      baseSlug,
      path,
      { replace: false }
    )

    @search = null
    @sidebarView.clearSearch()

    @sidebarView.render()
    @headerView.render()
    @renderSubview()

  navigateBack: ->
    if _.isEmpty @history
      return @navigate(null, null, null, true)

    { section, category, idPlugin } = @history.pop()
    @navigate(section, category, idPlugin, true)

  # ------- Subviews and UI Methods -------
  # When the upsell banner pops up we need to reduce the space in the directory body.
  setBodyHeight: (manuallyDismissed) ->
    if manuallyDismissed || (@model.canEnableAdditionalPowerUps())
      @$('.js-directory-body').removeClass('has-upsell')
    else if !Auth.me().isAdDismissed('DirectoryBusinessClassBanner')
      @$('.js-directory-body').addClass('has-upsell')

  homeSubview: ->
    @subview(DirectoryHomeView, @model, {
      plugins: @getFeaturedPlugins()
      currentPage: @getCurrentPage()
      directoryView: @
    })

  enabledSubview: ->
    @subview(DirectoryEnabledView, @model, {
      plugins: @plugins
      currentPage: @getCurrentPage()
      directoryView: @
    })

  pluginListingSubview: ->
    plugin = _.find @plugins, (p) => p.id == @idPlugin

    if !plugin
      return @navigate()

    @subview(DirectoryListingView, @model, {
      plugin
      currentPage: @getCurrentPage()
      directoryView: @
    })

  searchSubview: ->
    @trackSearch()
    @subview(DirectorySearchView, @model, {
      plugins: @getPluginsForSearch(),
      searchTerm: @search,
      currentPage: @getCurrentPage()
      directoryView: @
    })

  pageSubView: (title, plugins) ->
    @subview(DirectoryPageView, @model, {
      title
      plugins
      currentPage: @getCurrentPage()
      directoryView: @
    })

  renderSubview: ->
    # Clear out current subview
    @$contentContainer = @$('#directory-content')
    @$contentContainer.empty()
    if @activeSubview?
      @deleteSubview(@activeSubview)

    # Fancy CoffeeScript switch on nothing.
    # switch statements can also be used without a control expression,
    # turning them in to a cleaner alternative to if/else chains. :shrug:
    @activeSubview = switch
      when @isLoading then @subview(DirectorySpinnerView, @model)
      when @search then @searchSubview()
      when @section == 'category' && @category then @pageSubView(@category, @getPluginsForCategory())
      when @section == 'custom' then @pageSubView(@section, @getCustomPlugins())
      when @section == 'enabled' then @enabledSubview()
      when @idPlugin then @pluginListingSubview()
      else @homeSubview()

    @appendSubview(@activeSubview, @$contentContainer)

  # This sets up the layout of the directory.
  renderOnce: ->
    @appendSubview(@headerView)

    @$el.append('<div class="directory-body js-directory-body"></div>')
    @$directoryBody = @$('.js-directory-body')

    # If the upsell banner is present.
    @setBodyHeight()

    @$directoryBody.append('<div class="directory-responsive-overlay js-directory-responsive-overlay"></div>')

    @appendSubview(@sidebarView, @$directoryBody)

    @$directoryBody.append('<div id="directory-content"></div>')
    @renderSubview()

    return @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-view.coffee